import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "im-chat"
}
const _hoisted_2 = { class: "im-chat-top" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-v-xinxi" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-v-xinxi" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "im-chat-main" }
const _hoisted_9 = { class: "im-chat-main-left" }
const _hoisted_10 = {
  class: "im-chat-main-box messages",
  id: "message-box"
}
const _hoisted_11 = { class: "im-chat-user" }
const _hoisted_12 = {
  key: 0,
  class: "message-info right"
}
const _hoisted_13 = {
  key: 1,
  class: "message-info"
}
const _hoisted_14 = ["onContextmenu"]
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = ["onContextmenu"]
const _hoisted_17 = ["src"]
const _hoisted_18 = ["onContextmenu"]
const _hoisted_19 = ["title", "href"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "file-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-v-xiazai" })
], -1)
const _hoisted_21 = { class: "file-text" }
const _hoisted_22 = { class: "file-name" }
const _hoisted_23 = ["onContextmenu"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "im-chat-footer" }
const _hoisted_26 = { class: "im-chat-tool" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-v-tupian" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-v-folderHeart" }, null, -1)
const _hoisted_29 = { class: "im-chat-send" }
const _hoisted_30 = {
  key: 0,
  class: "im-chat-users"
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { style: {"max-height":"300px","overflow-y":"scroll","padding":"20px 5px"} }
const _hoisted_33 = { class: "dialog-footer" }

import { useChatStore } from "@/store/chatStore";
import { useUserStore } from "@/store/userStore";
import {
  computed,
  getCurrentInstance,
  nextTick,
  onMounted,
  ref,
  watch,
} from "vue";
import Avatar from "@/components/Avatar.vue";
import Time from "@/components/Time.vue";
import Faces from "@/components/Faces.vue";
import HistoryMessage from "@/components/HistoryMessage.vue";
import Chat from "@/mode/Chat";
import Message from "@/mode/Message";
import ChatUtils from "@/utils/ChatUtils";
import ChatType from "@/config/ChatType";
import Upload from "@/components/upload/Upload.vue";
import GroupApi from "@/api/GroupApi";
import User from "@/mode/User";
import MessageApi from "@/api/MessageApi";
import Receipt from "@/mode/Receipt";
import MessageType from "@/utils/MessageType";
import UserApi from "@/api/UserApi";
import { storeToRefs } from "pinia";
import { logout } from "@/api/Login";
import showUser from "@/components/user-modal";
import showGroup from "@/components/group-modal";
import RightMenu from "@/components/menu/RightMenu";
import ChatsRadio from "@/components/ChatsRadio";
import { h } from "vue";
import { ElNotification } from "element-plus";
import AccountApi from "@/api/AccountApi";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

export default /*#__PURE__*/_defineComponent({
  __name: 'ChatMessage',
  setup(__props) {

const { proxy } = getCurrentInstance();
const chatStore = useChatStore();
const userStore = useUserStore();

//是否展示表情
const showFace = ref(false);
//转发
const dialogVisible = ref(false);
//展示用户信息
const show = ref(false);
//群人数
const count = ref(0);

//语音
const Audio = ref();

//控制播放还是暂停音频文件
const handleAudio = (item: Message) => {
  if (Audio.value.paused) {
    Audio.value.src = item.extend.url;
    Audio.value.play();
  } else {
    Audio.value.src = "";
    Audio.value.stop();
  }
};

//用户
const users = ref<Array<User>>();

//是否展示聊天记录
const showHistory = ref(false);

//是否是群成员，如果是群聊天，并且已经被踢出群，不能再有发送按钮
const isGroupUser = ref(true);
//当前聊天
const chat = computed((): Chat => {
  return chatStore.chats[chatStore.index];
});
const user = userStore.getUser();
if (user) {
  userStore.storeUser(user.id, {
    name: user.name,
    avatar: user.avatar,
  });
}
if (!user) {
  logout().then(() => {
    proxy.$ws.close();
    AccountApi.toLogin();
  });
}
//聊天对象,
const { userMap } = storeToRefs(userStore);

if (chat.value && chat.value.type === ChatType.FRIEND) {
  UserApi.getUser(chat.value.id).then((res) => {
    const chatUser = res.data;
    userStore.storeUser(chatUser.id, {
      name: chatUser.name,
      avatar: chatUser.avatar,
    });
  });
}

watch(
  chat,
  (n) => {
    isGroupUser.value = true;
    if (n && chat.value.type === ChatType.GROUP) {
      GroupApi.users(n.id).then((res) => {
        res.data.forEach((item: User) => {
          userStore.storeUser(item.id, {
            name: item.name,
            avatar: item.avatar,
          });
        });
        users.value = res.data;
        count.value = res.data.length;
        isGroupUser.value =
          users.value?.find((item) => item.id === user?.id) !== undefined;
      });
    }
    if (n && user) {
      //第一次加载，从数据库中取100条，有序插入到聊天记录里
      MessageApi.list(n.id, user.id, n.type, 100).then((res) => {
        //读取消息
        readMessage();
        res.data.forEach((item: Message) => {
          chatStore.addToMessageList(item, n.id);
          nextTick(() => {
            ChatUtils.imageLoad("message-box");
          });
        });
      });
    }
  },
  {
    immediate: true,
    deep: true,
  }
);

const messageList = computed((): Array<Message> => {
  return chatStore.chatMessage.get(chat.value.id) ?? new Array<Message>();
});

/**
 * 用户点击消息列表某一个人,表示已经读取此人发送的所有的消息
 */
const readMessage = () => {
  if (user) {
    let receipt: Receipt = {
      chatId: chat.value.id,
      userId: user.id,
      timestamp: new Date().getTime(),
      type: chat.value.type,
    };
    proxy.$ws.sendRead(receipt);
  }
};

// 附件和图片点击展开
const openImageProxy = (event: any) => {
  event.preventDefault();
  const target = event.currentTarget;
  if (target.nodeName === "IMG") {
    proxy.$winControl.default.openURL(event.target.src);
  } else if (target.className === "file-box" || target.nodeName === "A") {
    proxy.$winControl.default.openURL(target.href);
  }
};

const messageContent = ref("");
const mineSend = (): void => {
  if (messageContent.value && messageContent.value.trim() !== "") {
    if (user) {
      let msg: Message = {
        messageType: MessageType.text,
        chatId: chat.value.id,
        fromId: user.id,
        // avatar: user.avatar,
        // name: user.name,
        mine: true,
        timestamp: new Date().getTime(),
        content: messageContent.value,
        type: chat.value.type,
      };
      proxy.$ws.sendMessage(msg);
      messageContent.value = "";
      nextTick(() => {
        ChatUtils.imageLoad("message-box");
      });
    }
  }
};

//添加表情
const insertFace = (item: string) => {
  messageContent.value = messageContent.value + "face" + item;
  showFace.value = false;
};

//上传成功
const uploadSuccess = (extend: string, messageType: string) => {
  if (user) {
    let msg: Message = {
      messageType: messageType,
      chatId: chat.value.id,
      fromId: user.id,
      mine: true,
      content: "",
      type: chat.value.type,
      extend: extend,
    };
    proxy.$ws.sendMessage(msg);
  }
};

//历史聊天记录
const history = () => {
  showHistory.value = !showHistory.value;
};

onMounted(() => {
  nextTick(() => {
    ChatUtils.imageLoad("message-box");
  });
});
//右键
const rightClickInfo = ref();
//右键
const onContextmenu = (item: Message, e: any) => {
  rightClickInfo.value = {
    position: {
      x: e.clientX,
      y: e.clientY,
    },
    menuLists: [
      {
        fnName: "retransmission",
        params: item,
        icoName: "el-icon-star-on",
        btnName: "转发",
      },
    ],
  };
};
//转发的聊天对象
const toChats = ref([] as Chat[]);
const msg = ref({} as Message);
//展示转发按钮
const showRetransmission = (message: Message) => {
  dialogVisible.value = true;
  msg.value = message;
};
//转发
const retransmission = () => {
  dialogVisible.value = false;
  let tempMsg: Message = JSON.parse(JSON.stringify(msg.value));
  toChats.value.forEach((item) => {
    if (null !== userStore.user) {
      tempMsg.chatId = item.id;
      tempMsg.fromId = userStore.user.id;
      tempMsg.type = item.type;
      tempMsg.mine = true;
      proxy.$ws.sendMessage(tempMsg);
      ElNotification({
        title: "提示",
        message: h("i", { style: "color: teal" }, "转发成功"),
      });
    }
  });
};
//子组件往父组件传递的值
const setData = (data: Chat[]) => {
  toChats.value = data;
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (chat.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(chat.value.name), 1),
              (chat.value.type === _unref(ChatType).GROUP)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "（" + _toDisplayString(count.value) + "人）", 1))
                : _createCommentVNode("", true)
            ]),
            (chat.value.type === _unref(ChatType).FRIEND)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "javascript:;",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(showUser)(chat.value.id, false))),
                  class: "pull-right menu"
                }, _hoisted_5))
              : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: "javascript:;",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(showGroup)(chat.value.id, false))),
                  class: "pull-right menu"
                }, _hoisted_7))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageList.value, (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.id,
                      class: _normalizeClass({ 'im-chat-mine': item.mine })
                    }, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(Avatar, {
                          img: _unref(userMap).get(item.fromId)?.avatar,
                          name: _unref(userMap).get(item.fromId)?.name
                        }, null, 8, ["img", "name"]),
                        (item.mine)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createElementVNode("i", null, [
                                _createVNode(Time, {
                                  time: item.timestamp
                                }, null, 8, ["time"])
                              ]),
                              _createElementVNode("span", null, _toDisplayString(_unref(userMap).get(item.fromId)?.name), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (!item.mine)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createElementVNode("span", null, _toDisplayString(_unref(userMap).get(item.fromId)?.name), 1),
                              _createElementVNode("i", null, [
                                _createVNode(Time, {
                                  time: item.timestamp
                                }, null, 8, ["time"])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (item.messageType === _unref(MessageType).text)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "im-chat-text",
                            onContextmenu: _withModifiers(($event: any) => (onContextmenu(item, $event)), ["prevent"]),
                            "data-id": "item.id"
                          }, [
                            _createElementVNode("pre", {
                              innerHTML: _unref(ChatUtils).transform(item.content)
                            }, null, 8, _hoisted_15)
                          ], 40, _hoisted_14))
                        : _createCommentVNode("", true),
                      (item.messageType === _unref(MessageType).image)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "im-chat-text",
                            onContextmenu: _withModifiers(($event: any) => (onContextmenu(item, $event)), ["prevent"]),
                            style: {"width":"50%","line-height":"100%","font-size":"inherit"}
                          }, [
                            _createElementVNode("img", {
                              src: item.extend.url,
                              style: {"width":"100%"},
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (openImageProxy($event)))
                            }, null, 8, _hoisted_17)
                          ], 40, _hoisted_16))
                        : _createCommentVNode("", true),
                      (item.messageType === _unref(MessageType).file)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: "im-chat-text",
                            onContextmenu: _withModifiers(($event: any) => (onContextmenu(item, $event)), ["prevent"]),
                            style: {"width":"50%"}
                          }, [
                            _createElementVNode("a", {
                              class: "file-box",
                              title: item.extend.fileName,
                              href: item.extend.url,
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (openImageProxy($event)))
                            }, [
                              _hoisted_20,
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, _toDisplayString(item.extend.fileName), 1)
                              ])
                            ], 8, _hoisted_19)
                          ], 40, _hoisted_18))
                        : _createCommentVNode("", true),
                      (item.messageType === _unref(MessageType).voice)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 3,
                            class: "im-chat-text",
                            onContextmenu: _withModifiers(($event: any) => (onContextmenu(item, $event)), ["prevent"]),
                            style: _normalizeStyle({
                  width:
                    item.extend.time > 40 ? '50%' : item.extend.time + 10 + '%',
                })
                          }, [
                            _createElementVNode("div", {
                              onClick: ($event: any) => (handleAudio(item))
                            }, [
                              _createElementVNode("i", {
                                class: _normalizeClass(["iconfont icon-v-voice", { 'icon-v-voice-right': item.mine }])
                              }, null, 2)
                            ], 8, _hoisted_24)
                          ], 44, _hoisted_23))
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                ]),
                _createElementVNode("audio", {
                  ref_key: "Audio",
                  ref: Audio
                }, null, 512)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("i", {
                    class: "iconfont icon-v-smile",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (showFace.value = !showFace.value))
                  }),
                  _createVNode(Upload, {
                    "is-img": true,
                    fileTypes: ['png', 'jpg', 'jpeg', 'gif'],
                    onUploadSuccess: uploadSuccess
                  }, {
                    default: _withCtx(() => [
                      _hoisted_27
                    ]),
                    _: 1
                  }),
                  _createVNode(Upload, {
                    "is-img": false,
                    fileTypes: ['doc', 'docx', 'xls', 'xlsx', 'pdf', 'zip', 'rar'],
                    onUploadSuccess: uploadSuccess
                  }, {
                    default: _withCtx(() => [
                      _hoisted_28
                    ]),
                    _: 1
                  }),
                  (showFace.value)
                    ? (_openBlock(), _createBlock(Faces, {
                        key: 0,
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (showFace.value = false)),
                        class: "faces-box",
                        onInsertFace: insertFace
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_button, {
                    class: "history-message-btn",
                    size: "small",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (history()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("聊天记录 ")
                    ]),
                    _: 1
                  })
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((messageContent).value = $event)),
                  class: "textarea",
                  onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => (mineSend()), ["enter"]))
                }, null, 544), [
                  [_vModelText, messageContent.value]
                ]),
                _createElementVNode("div", _hoisted_29, [
                  (isGroupUser.value)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "primary",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (mineSend()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("发送 ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!isGroupUser.value)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        type: "primary",
                        disabled: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("不在群内 ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (chat.value.type === _unref(ChatType).GROUP)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createVNode(_component_el_scrollbar, { class: "chat-user-list" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "user",
                          key: item.id,
                          onClick: ($event: any) => (_unref(showUser)(item.id, true))
                        }, [
                          _createVNode(Avatar, {
                            img: item.avatar,
                            name: item.name
                          }, null, 8, ["img", "name"]),
                          _createTextVNode(" " + _toDisplayString(item.name), 1)
                        ], 8, _hoisted_31))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_drawer, {
      modelValue: showHistory.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((showHistory).value = $event)),
      title: "聊天记录",
      "with-header": false,
      size: "60%"
    }, {
      default: _withCtx(() => [
        _createVNode(HistoryMessage, {
          "from-id": _unref(userStore).user.id,
          "chat-users": _unref(userMap),
          "chat-id": chat.value.id,
          type: chat.value.type,
          showHistory: showHistory.value
        }, null, 8, ["from-id", "chat-users", "chat-id", "type", "showHistory"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(RightMenu), {
      "class-index": 0,
      rightClickInfo: rightClickInfo.value,
      onRetransmission: showRetransmission
    }, null, 8, ["rightClickInfo"]),
    _createVNode(_component_el_dialog, {
      width: "500px",
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((dialogVisible).value = $event)),
      "show-close": false,
      "destroy-on-close": true,
      title: "消息转发"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_33, [
          _createVNode(_component_el_button, {
            onClick: _cache[11] || (_cache[11] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: retransmission
          }, {
            default: _withCtx(() => [
              _createTextVNode("转发")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_unref(ChatsRadio), { onSetData: setData })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})